/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';

import { apiConfig } from '@/config/apiConfig';

import { Graphql } from '@common/graphql';
import { UPDATE_KYC_DOCS } from '@pages/MyProfilePage/apis/graphql';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator/services';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IUpdateKycMethods extends IPluginMethodMap {
  getUpdateKyc(args: any): Promise<any>;
}

export interface UpdateKycProps {
  addressProofType?: string;
  idProofType?: string;
  addressProof?: any;
  idProof?: any;
}

export class UpdateKycPlugin implements IAgentPlugin {
  readonly methods: IUpdateKycMethods;

  constructor() {
    this.methods = {
      getUpdateKyc: this.getUpdateKyc.bind(this),
    };
  }

  async getUpdateKyc(args: UpdateKycProps) {
    return await this.updateKyc(args);
  }

  private async updateKyc(args: UpdateKycProps) {
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      // const token = getToken();
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const res = await client
        .mutation(UPDATE_KYC_DOCS, {
          input: {
            documents: this.getDocuments(args),
          },
        })
        .toPromise();

      if (res?.data) {
        return {
          data: res?.data?.editKYCDoc?.message,
        };
      }
    } catch (err: any) {
      throw err;
    }
  }

  private getDocuments(args: any) {
    let _docs = [];
    if (args?.idProofType) {
      _docs.push({
        doc: args?.idProof[0]?.base64,
        type: 'ID_PROOF',
        name: args?.idProofType,
        status: 'SUBMITTED',
      });
    }
    if (args?.addressProofType) {
      _docs.push({
        doc: args?.addressProof[0]?.base64,
        type: 'ADDRESS_PROOF',
        name: args?.addressProofType,
        status: 'SUBMITTED',
      });
    }
    return _docs;
  }
}
